import { breakpoints, spaces } from '../../lib/styles';
import { Property, ResponsiveSpace, ResponsiveAlignment, ThemeSpaces } from './types/styles';

interface StyleAttributes extends BoxStylesProps {
    [key: string]: ResponsiveSpace | ResponsiveAlignment | undefined;
}

export interface BoxStylesProps {
    paddingTop?: ResponsiveSpace;
    paddingRight?: ResponsiveSpace;
    paddingBottom?: ResponsiveSpace;
    paddingLeft?: ResponsiveSpace;
    textAlign?: ResponsiveAlignment;
}

export const boxStyles = (attributes: StyleAttributes) => {
    const properties: StyleAttributes = Object.assign({}, attributes);

    Object.keys(properties).forEach(
        (key: string) => properties[key] === undefined && delete properties[key]
    );

    return getStylesForBreakpoints(properties);
};

function getStylesForBreakpoints(attributes: StyleAttributes) {
    const styles: {
        [key: string]: string;
    } = {};

    Object.keys(breakpoints).forEach((breakpoint: string, index) => {
        const declarations = Object.keys(attributes)
            .map((key: Property) => getDeclaration(key, getPropertyValue(attributes[key], index)))
            .join('');

        if (declarations.length) {
            styles[breakpoint] = declarations;
        }
    });

    return styles;
}

function propertyMap(key: string) {
    const map: {
        [key: string]: string;
    } = {
        paddingTop: 'padding-top',
        paddingRight: 'padding-right',
        paddingBottom: 'padding-bottom',
        paddingLeft: 'padding-left',
        textAlign: 'text-align',
    };

    return map[key];
}

function getPropertyValue(propertyValue: any, index: number) {
    return typeof propertyValue === 'string' ? propertyValue : propertyValue[index];
}

function getDeclaration(propertyKey: Property, propertyValue: Property) {
    return propertyValue && propertyValue !== 'none'
        ? `${propertyMap(propertyKey)}:${matchStyleValue(propertyValue)};`
        : '';
}

function matchStyleValue(value: string) {
    const match = value.match(/space|\d+px|\d+%|left|right|center/);

    if (match && match[0] === 'space') {
        const themeSpaces: ThemeSpaces = spaces;

        return `${themeSpaces[value]}px`;
    } else if (match) {
        return value;
    }

    throw new Error(`matchStyleProperty: Could not match style ${value}`);
}
